/* Native details work without JS. Enhance dismissal and pointer navigation. */
(() => {
  if (window.fioriHeaderInitialized) return;
  window.fioriHeaderInitialized = true;
  const closing = new WeakMap();
  function cancelClose(menu) {
    const animation = closing.get(menu);
    if (animation) { closing.delete(menu); animation.cancel(); }
  }
  function closeMenu(menu, immediate = false) {
    if (!menu.open) return;
    if (closing.has(menu) && !immediate) return;
    cancelClose(menu);
    const panel = menu.querySelector('.fiori-mega');
    if (immediate || !panel?.animate || document.body.dataset.fioriMotion === 'false' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      menu.open = false;
      return;
    }
    const animation = panel.animate([{opacity:1},{opacity:0}], {duration:180,easing:'ease-out',fill:'forwards'});
    closing.set(menu, animation);
    animation.onfinish = () => {
      if (closing.get(menu) !== animation) return;
      closing.delete(menu);
      menu.open = false;
      animation.cancel();
    };
  }
  function initialize(root = document) {
    root.querySelectorAll('.fiori-menu').forEach(menu => {
      if (menu.dataset.fioriReady) return;
      menu.dataset.fioriReady = 'true';
      const header = menu.closest('header-component');
      let timer;
      menu.addEventListener('toggle', () => {
        if (menu.open) header.querySelectorAll('.fiori-menu').forEach(other => {
          if (other !== menu) closeMenu(other, true);
        });
      });
      menu.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(timer);
        cancelClose(menu);
        menu.open = true;
      });
      menu.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        timer = setTimeout(() => {
          if (!menu.querySelector(':focus-visible')) closeMenu(menu);
        }, 180);
      });
      menu.addEventListener('focusout', () => {
        setTimeout(() => { if (!menu.contains(document.activeElement)) closeMenu(menu); }, 0);
      });
      menu.querySelector('summary').addEventListener('click', event => {
        if (event.target.closest('a')) return;
        if (menu.open) { event.preventDefault(); closeMenu(menu); }
      });
      menu.addEventListener('focusin', () => cancelClose(menu));
      menu.querySelector('.fiori-menu__destination')?.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown') {
          event.preventDefault(); cancelClose(menu); menu.open = true;
          menu.querySelector('.fiori-mega a')?.focus();
        }
      });
    });
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('.fiori-menu[open]').forEach(menu => {
      if (!menu.contains(event.target)) closeMenu(menu);
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.fiori-menu[open]').forEach(menu => {
      closeMenu(menu, true);
      if (menu.contains(document.activeElement)) (menu.querySelector('.fiori-menu__destination') || menu.querySelector('summary')).focus();
    });
  });
  window.addEventListener('resize', () => {
    const header = document.querySelector('[data-fiori-header]');
    if (header) header.dataset.menuStyle = window.innerWidth >= 1200 ? 'menu' : 'drawer';
    if (window.innerWidth < 1200) document.querySelectorAll('.fiori-menu[open]').forEach(menu => closeMenu(menu, true));
  });
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
